import { structure } from '@dofleini/location';
import { client, contract } from '@ahab/oficinav-commons';
import map from 'lodash/map';
import mapFP from 'lodash/fp/map';
import valuesFP from 'lodash/fp/values';
import compose from 'lodash/fp/compose';
import flattenFP from 'lodash/fp/flatten';
import find from 'lodash/find';
import i18n from 'i18next';
import { PAYMENT_TYPES } from '@/modules/payments/contants/payments';

const { BIG_CLIENT_PROCEDURE_TYPE, BIG_CLIENT_REQ_REASON, RESIDENTIAL_PROCEDURE_TYPE, RESIDENTIAL_REQ_REASON } = contract;

export const municipalityOptions = compose(
  mapFP(({ name: label, code: value }) => ({ label, value })),
  flattenFP,
  valuesFP,
)(structure.MUNICIPALITIES);

export const userTypesOptions = map(client.CLIENT_TYPE, (label, value) => ({
  label: i18n.t(`common:userType:${value}`),
  value
}));
export const bigClientProcedureTypesOptions = map(BIG_CLIENT_PROCEDURE_TYPE, (label, value) => ({
  label: i18n.t(`common:PROCEDURE_TYPE:${value}`),
  value
}));

export const residentialClientProcedureTypesOptions = map(RESIDENTIAL_PROCEDURE_TYPE, (label, value) => ({
  label: i18n.t(`common:PROCEDURE_TYPE:${value}`),
  value
}));

export const bigClientReasonOptions = map(BIG_CLIENT_REQ_REASON, (label, value) => ({
  label: i18n.t(`common:BIG_CLIENT:${value}`),
  value
}));

export const residentialClientReasonOptions = map(RESIDENTIAL_REQ_REASON, (label, value) => ({
  label: i18n.t(`common:RESIDENTIAL:${value}`),
  value
}));

export const paymentsTypesOptions = map(PAYMENT_TYPES, (label, value) => ({
  label: i18n.t(`common:PAYMENT_TYPE:${value}`),
  value
}));
export const renderMunicipality = (code) => structure.findMunicipalityByCode(code)?.name || '-';
export const renderUserTypes = value => find(userTypesOptions, { value })?.label || '-';


